import { Panels } from "@msuite/ui/panels";
import { DataTable } from "@msuite/ui/table";
import { getPayableAmounts } from "@msuite/utils/incoming-invoices";
import { useIncomingInvoice } from "@/hooks/use-incoming-invoice";
import type { IncomingInvoicePanelBaseProps } from "../../shared";
import { CostAllocationMenu } from "./cost-allocation-menu";
import type { CostAllocationRow } from "./cost-allocation-row";
import { CostAllocationSummary } from "./cost-allocation-summary";
import { columns } from "./table-config";

/**
 * How the invoice's net amount splits across the organisation's cost centres: what is allocated
 * and what is left on the left, the rows on the right with the edit beside the search.
 */
export function IncomingInvoiceCostAllocation({
	incomingInvoiceId,
}: IncomingInvoicePanelBaseProps) {
	/** Query */
	const { incomingInvoice, isLoading, queryKey, refetch } = useIncomingInvoice(incomingInvoiceId);

	/** Computed */
	const netAmount = incomingInvoice ? getPayableAmounts(incomingInvoice).netAmount : null;
	const rows: CostAllocationRow[] = [];
	for (const allocation of incomingInvoice?.costAllocations ?? []) {
		if (!incomingInvoice) break;
		rows.push({
			...allocation,
			share: netAmount ? (allocation.amount / netAmount) * 100 : null,
			currency: incomingInvoice.currency,
			incomingInvoice,
		});
	}

	/** Render */
	return (
		<Panels>
			<Panels.Panel
				flex={1}
				className="bottom-space"
			>
				<CostAllocationSummary incomingInvoice={incomingInvoice} />
			</Panels.Panel>
			<Panels.Panel flex={2}>
				<DataTable
					data={rows}
					columns={columns}
					isLoading={isLoading}
					queryKey={queryKey}
					refetch={refetch}
					menu={<CostAllocationMenu incomingInvoice={incomingInvoice} />}
					persistenceKey="incoming-invoice-cost-allocation-table"
				/>
			</Panels.Panel>
		</Panels>
	);
}
